export enum GridType {
  GRID = 'GRID',
  GRID_FOR_FUND_PORTFOLIOS = 'GRID_FOR_FUND_PORTFOLIOS',
  ROWS = 'ROWS',
}
